import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { ELocalisationRejet } from "./enum/location-rejet";
import { ETypeMateriel } from "./enum/materiel-type";

export class MaterielEau {
    @AutoMap()
    Type?: ETypeMateriel;
    @AutoMap()
    Reference?: string;
    @AutoMap()
    NombreDouche?: number;
    @AutoMap()
    DateChangementFiltre?: Temporal.PlainDate;
    @AutoMap()
    LocalisationRejet?: ELocalisationRejet;
    @AutoMap()
    Materiau!: string;
    
    public constructor(init?: Partial<MaterielEau>) {
        Object.assign(this, init);
    }
}